const validThresholdDurationRegExp = new RegExp('^(0{0,}\\d{0,4}:[0-5]\\d$)');

export { validThresholdDurationRegExp };
